export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading text-accent-400">51吃瓜黑料</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              国内领先的娱乐八卦与黑料爆料视频在线观看平台。每日更新海量51吃瓜黑料视频，吃瓜视频、黑料视频全覆盖，免费高清流畅播放。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">首页</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">热门话题</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">黑料精选</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">专题合集</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">内容板块</h4>
            <ul className="space-y-2.5">
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">吃瓜热度榜</a></li>
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">焦点爆料</a></li>
              <li><a href="#media" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">热门视频</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">最新动态</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-100 mb-4">关于平台</h4>
            <ul className="space-y-2.5">
              <li><a href="#about" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">关于我们</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">常见问题</a></li>
              <li><a href="#contact" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">投稿爆料</a></li>
              <li><a href="#app" className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200 cursor-pointer">移动端入口</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/40">
          <h4 className="text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
          <div className="flex flex-wrap gap-3 mb-8">
            <span className="px-4 py-2 rounded-lg bg-background-800 text-sm text-background-400">虚位以待</span>
            <span className="px-4 py-2 rounded-lg bg-background-800 text-sm text-background-400">诚邀加盟</span>
            <span className="px-4 py-2 rounded-lg bg-background-800 text-sm text-background-400">商务合作</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-background-700/40 text-xs text-background-500 gap-3">
          <span>© 2024-2026 51吃瓜黑料. All rights reserved.</span>
          <span>吃瓜不迷路，黑料不错过 — 51吃瓜黑料</span>
        </div>
      </div>
    </footer>
  );
}